<template>

<com-item name="ratings.disparities" :is-list="true" :is-blank="true" :has-more="true" v-on:more="onMoreClick" :size="size" :is-empty="!active" :loading="loading" title="Disparities">

	<template v-slot:about>

		<p>Which of {{ your }} ratings have the biggest difference with the BGG community.</p>

	</template>

	<template v-slot:stats>

		<div class="disparity-content">
		
			<div class="disparity-list">

				<app-game v-for="(item, index) in data.games" :item="{id: item.game.id}" v-bind:key="index" :subtext="subtext(item)">

					<core-rating :value="item.group.rating_avg" :count="item.group.rating_count" :ratings="item.users.rated" v-on:more="onMoreClick(item.game.id)" class="item-rating" :showIndividualRatings="isGroup" :hideCount="!isGroup" :transparent="true" />
				
					<app-game-item-field-rating :item="item" :format="{context: 'bgg'}"  />

				</app-game>

			</div>

			<div class="disparity-metrics">

				<com-overview label="Average Difference" type="number" info="Your average rating compared to the community." :value="data.metrics.avg | round(2)" :auto-theme="true" />

				<com-overview label="Mean Gap" info="The typical size of the disparity." type="number" :value="data.metrics.gap | round(2)" />

				<com-overview label="Agree by ≤ 1" type="percent" info="Ratings that are within 1 point." :value="data.metrics.consistency" />

				<com-overview label="Disagree by ≥ 2.0" type="percent" info="Ratings that differ by more than 2 points." :value="data.metrics.disagreements" />

				<com-overview label="Rating Bias" type="segments" :config="bias" info="How often you rate higher or lower than community." :value="data.metrics.overunder" />

				<com-overview label="Dispersion Score" type="band" :config="dispersion" info="How much your rating differences vary overall." :value="data.metrics.dispersion | round(2)" />

			</div>
		
		</div>

	</template>

	<template v-slot:buttons>

		<com-toggle :options="typeOptions" :value="typeValue" v-on:change="onTypeChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'
import comOverview from './../common/Overview'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		comItem,
		comOverview,
		comToggle
	},

	data: function() {

		return {
			bias: {
				max: 100,
				labels: ['<', '=', '>'],
				themes: ['#df4751', '#4881bb', '#2FC482']
			},
			dispersion: {
				bands: {
					0: 'Consistent',
					80: 'Moderate',
					140: 'Opinionated'
				},
				subtitles: {
					0: 'something',
					80: 'something',
					140: 'something'
				}
			}
		}

	},

	computed: {

		typeOptions: function() {

			var options = []

			options.push({value: 'all', text: 'All'})
			options.push({value: 'under', text: 'Under'})
			options.push({value: 'over', text: 'Over'})

			return options

		},

		typeValue: function() {

			return this.$store.getters['filter/insights/ratings/disparity']

		},

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'disparity'

		},

		data: function() {

			return this.$store.getters['page/insights/ratings/disparities']

		},

		active: function() {

			return this.data.games.length && !this.loading

		}

	},

	methods: {

		onTypeChange: function(value) {

			this.$store.commit('filter/insights/ratings/disparity', value)

		},

		subtext: function(item) {

			var difference = 0

			if (this.$store.getters['context/is/user']) {

				difference = Math.abs(item.user.rating_avg - item.game.rating_avg).toFixed(1)

			} else {

				difference = Math.abs(item.group.rating_avg - item.game.rating_avg).toFixed(1)

			}

			return 'Rating disparity of ' + difference

		},

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsRatingsDisparities'
			})

		}
	
	}

}

</script>

<style scoped>

.disparity {
	width: 100%;
	padding: 0px!important;
}

.disparity-content {
	display: grid;
    grid-gap: 5px;
	min-height: 320px;
    grid-template-columns: 1fr 320px;
    grid-template-rows: 1fr;
}

.is-mobile .disparity-content {
    grid-template-columns: 1fr;
}

.disparity-list {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.disparity-metrics {
	display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-gap: 5px;
}

.is-mobile .disparity-metrics {
	display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 5px;
}

</style>